module.exports = "<div class=\"wrapper\">\r\n    <router-outlet></router-outlet>\r\n</div>"